import LangEnum from '../../../../../../../../lang/LangEnum';
import { CatalogCreationBooleanOptions } from '../../../../../../creation/catalogCreationForm.types';
import { NavigationColorMode } from '../../../../../../enums/navigationColorMode.enum';

export const CATALOG_DETAILS_NAVIGATION_COLOR_MODE_LANG: Record<NavigationColorMode, LangEnum> = {
  [NavigationColorMode.ALL_COLORS]: LangEnum.CATALOG_DETAILS_DISPLAYED_COLORS_ALL,
  [NavigationColorMode.CATALOG_PRODUCT_COLORS]: LangEnum.CATALOG_DETAILS_DISPLAYED_COLORS_CATALOG,
};

export const CATALOG_DETAILS_RELATED_PRODUCTS_OPTIONS: CatalogCreationBooleanOptions = [
  { value: false, label: LangEnum.GLOBAL_MALE_ALL },
  { value: true, label: LangEnum.CATALOG_DETAILS_RELATED_PRODUCTS_CATALOG },
];

export const CATALOG_DETAILS_PRODUCT_COLOR_CARDS_OPTIONS: CatalogCreationBooleanOptions = [
  { value: false, label: LangEnum.CATALOG_DETAILS_PRODUCT_COLOR_CARDS_PER_COLOR },
  { value: true, label: LangEnum.CATALOG_DETAILS_PRODUCT_COLOR_CARDS_GROUPED },
];
